export const RECIEVE_ACCESS_TOKEN = "RECIEVE_ACCESS_TOKEN";
export const RECIEVE_AUTHED_USER = "RECIEVE_AUTHED_USER";
export const RESET_AUTH = "RESET_AUTH";

export const REQUEST_USER_AUTH = "REQUEST_USER_AUTH";
export const REQUEST_USER_AUTH_WITH_TOKEN = "REQUEST_USER_AUTH_WITH_TOKEN";
export const USER_AUTH_SUCCESS = "USER_AUTH_SUCCESS";
export const USER_AUTH_ERROR = "USER_AUTH_ERROR";

export const CLEAR_STATUS_STATE = "AUTHORIZATION_CLEAR_STATUS_STATE";



// WEBPACK FOOTER //
// ./src/modules/session/types.js